import {
  createFormater,
  ruleAdapter,
} from '@product/components/ProductThumb/helpers'

export const RecommendationProduct = {
  fromAPI(
    apiData = {},
    { hasCarrier, attributesRules = [], titleRules = [], sourceType } = {},
  ) {
    const {
      compatible_carriers: compatibleCarriers,
      default_warranty: defaultWarranty,
      grade,
      id,
      is_sim_locked: isSimLocked,
      isVanishingDeal,
      link,
      name,
      pressureStockLimit,
      price_original_with_currency: priceOriginalWithCurrency,
      price_original: priceOriginal,
      price_with_currency: priceWithCurrency,
      price,
      product_id: productId,
      stockRaw,
      sub_title_elements: subTitleElements,
      thumbnail,
      title_model: titleModel,
    } = apiData

    return {
      attributes: attributesRules.map(({ label, attributes }) => {
        const format = createFormater(attributes.map(ruleAdapter))

        return { label, attributes: format(apiData) }
      }),
      carriers: {
        list: compatibleCarriers,
        locked: isSimLocked,
        hasCarrier,
      },
      grade,
      id: productId,
      isRecommendation: true,
      isVanishing: isVanishingDeal,
      link,
      name: createFormater(titleRules.map(ruleAdapter))(apiData),
      originalPrice: {
        raw: priceOriginal,
        display: priceOriginalWithCurrency,
      },
      pressureStockLimit,
      price: { raw: price, display: priceWithCurrency },
      sourceType,
      stockRaw,
      subTitleModel: subTitleElements,
      thumbnail,
      title: name,
      titleModel,
      warranty: defaultWarranty,
      apiData,
      objectID: id,
      productId,
    }
  },

  toTrackingData(product, { position, dealType, source, provider }) {
    return {
      sourceType: product.sourceType,
      brand: product.apiData.brand,
      category: product.apiData.category,
      name: product.apiData.name,
      id: product.apiData.product_id,
      uuid: product.apiData.link?.params.uuid,
      backmarketID: product.apiData.product_id,
      price: product.apiData.price,
      list: product.sourceType,
      variant: product.apiData.backbox_grade_value,
      merchantId: product.apiData.merchant_id,
      listingId: product.apiData.id,
      objectID: product.apiData.id,
      position,
      dealType,
      source,
      provider,
    }
  },
}
